// export let Fix_value = [
//   "Furniture",
//   "Bathroom: bath",
//   "Laundry facilities: in the basement",
//   "Private entrance",
//   "Storage",
//   "Elevator",
//   "Garage",
// ];

export let Fix_value = [
  "Furniture",
  "bathroomBath",
  "laundryFacilitiesInTheBasement",
  "privateEntrance",
  "Storage",
  "Elevator",
  "Garage",
];
export let Fix_value_id = [
  "63c8e8ecd80f76d394272c1a",
  "63c8e8b3d80f76d394272b43",
  "63c8e8a6d80f76d394272b3b",
  "63c8e898d80f76d394272b33",
  "63c8e88ad80f76d394272b2b",
  "63c8e437d80f76d394272983",
  "63c8e3f1d80f76d39427297b",
  "63c8e3cad80f76d394272973",
]

export const settings = {
  className: "center",
  // dots: true,
  swipeToSlide: true,
  focusOnSelect: true,
  centerPadding: "15px",
  slidesToShow: 4,
  arrows: true,
  autoplay: true,
  autoplaySpeed: 2000,
  responsive: [
    {
      breakpoint: 1440,
      settings: {
        slidesToShow: 3,

        infinite: true,
        dots: true,
        autoplay: true,
        autoplaySpeed: 2000,
      },
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        arrows: true,
        infinite: true,
        dots: true,
        autoplay: true,
        autoplaySpeed: 2000,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        arrows: true,
        initialSlide: 2,
        slidesToScroll: 2,
        // dots: true,
        autoplay: true,
        autoplaySpeed: 3000,
      },
    },

    {
      breakpoint: 480,
      settings: {
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        // dots: true,
        autoplay: true,
        autoplaySpeed: 2000,
      },
    },
  ],
};

export const silderData = [
  {
    image: "assets/image8.jpg",
    address: "Gerplustræti, 270",
    description: "Apartment, 4 rooms, 74m²",
    price: "20,0000 kr.",
  },
  {
    image: "assets/image7.jpg",
    address: "Lindasmári, 201 Kóp.",
    description: "Apartment, 2 rooms, 74m²",
    price: "10,0000 kr.",
  },

  {
    image: "assets/image5.jpg",
    address: "Vesturbraut, 220 Hfj.",
    description: "Apartment, 5 rooms, 74m²",
    price: "30,0000 kr.",
  },
  {
    image: "assets/image4.jpg",
    address: "Vesturbraut, 220 Hfj.",
    description: "Apartment, 5 rooms, 74m²",
    price: "30,0000 kr.",
  },
  {
    image: "assets/image3.jpg",
    address: "Vesturbraut, 220 Hfj.",
    description: "Apartment, 5 rooms, 74m²",
    price: "30,0000 kr.",
  },
  {
    image: "assets/iamge2.jpg",
    address: "Vesturbraut, 220 Hfj.",
    description: "Apartment, 5 rooms, 74m²",
    price: "30,0000 kr.",
  },
];

// var finalArray = images.map(function (obj) {
//   return obj;
// });

// export let home_appliances = [
//   "Stove: Four burner",
//   "Refrigerator",
//   "Dishwasher",
//   "Washing machine",
//   "Dryer",
//   "Television",
//   "Internet",
// ];

export let home_appliances = [
  "stove",
  "Refrigerator",
  "Dishwasher",
  "washingMachine",
  "Dryer",
  "Television",
  "Internet",
];

export let home_appliances_id = [
  "63c8ead3d80f76d394272e4c",
  "63c8eabfd80f76d394272e44",
  "63c8eab2d80f76d394272e3c",
  "63c8eaa1d80f76d394272e34",
  "63c8ea95d80f76d394272df9",
  "63c8ea86d80f76d394272df1",
  "63c8ea79d80f76d394272de9",
]

export let restrictions_val = [
  "Pets",
  "Co-tenant",
  "Smoking",
  // "Both sexes: Lorem ipsum",
  "Property for sale",
  "Permitted number of inhabitants",
];

export let restrictions_val_id = [
  "63c8ea63d80f76d394272dae",
  "63c8ea29d80f76d394272d73",
  "63c8ea1ad80f76d394272d46",
  "63c8e9c2d80f76d394272cd5",
  "63c8e946d80f76d394272c63",
  "63c8e928d80f76d394272c5b",
]

export const images = [
  {
    original: "assets/image1.jpg",
    thumbnail: "assets/image1.jpg",
  },
  {
    original: "assets/image3.jpg",
    thumbnail: "assets/image3.jpg",
  },
  {
    original: "assets/image4.jpg",
    thumbnail: "assets/image4.jpg",
  },
  {
    original: "assets/image5.jpg",
    thumbnail: "assets/image5.jpg",
  },
];
